export const translation = {
    notifications: {
        Initiated: '{{- table}} is being deployed to {{target}}',
        Succeeded: 'Transformation has been {{ deployMethod }} as {{ deployedAs }}.',
        errorPrefix: 'Failed to deploy transformation: ',
        errorSuffix: ' for table "{{- table }}"'
    },
    dialog: {
        titleDeploy: 'Deploy to Snowflake',
        titleRedeploy: 'Re-deploy to Snowflake',
        nameFieldLabel: 'Name',
        deploymentMessageFieldLabel: 'Message',
        deployAsLabel: 'Deploy as',
        deployAsToolTipView: `<strong>Views:</strong> The result of a query that can be
        accessed as if it were a table. Performance is slower than
        Tables and results are not stored for future use. Views may join
        several tables into a single result set.`,
        deployAsToolTipTable: `<strong>Tables:</strong> Results are stored, almost as though
        the results were a table. This allows faster access, but
        requires storage space and active maintenance.`,
        deployButtonText: 'Deploy Data',
        redeployButtonText: 'Re-deploy Data',
        initialDeploymentMessage: 'Initial deployment'
    },
    formFields: {
        name: {
            startsWithCharacter: 'A Snowflake table name must start with a letter or underscore.',
            contains: 'A Snowflake table name may contain only digits, letters or underscores.',
            required: 'Please provide a name',
            min: 'Sorry, names should be at least 3 characters long',
            max: 'Sorry, names can only be 100 characters long'
        },
        role: {
            required: 'Please select a Role'
        },
        warehouse: {
            required: 'Please select a Warehouse',
            empty: 'There are no Warehouses associated with this Role, please select another Role'
        },
        placeholders: {
            role: 'Select role',
            loadingRole: 'Loading Roles…',
            warehouse: 'Select warehouse',
            loadingWarehouse: 'Loading Warehouses…'
        }
    },
    restoreDialog: {
        title: 'Restore Previous Deployment to Snowflake',
        defautMessage: 'Restored [v{{version}} - {{- oldmessage}}]',
        description: 'Restoring will <strong>DEPLOY</strong> to Snowflake the SQL for the versions:<br /><strong>{{- oldmessage}}</strong> from <strong><time/></strong>.<br/><br/>This will NOT change the current Workbench transformations.'
    }
};
